// Shared "Content type" filter options used by the Testimonials (ContentInbox)
// and Approved Testimonials views. The "all" value is the no-filter sentinel,
// matching the convention used by the Status filter in both views.
// NOTE: some values intentionally contain a space (e.g. "lawyer leading_juniors").
export const contentTypeOptions: { value: string; label: string }[] = [
  { value: "all", label: "All Content Types" },
  { value: "clerk_testimonial", label: "Clerking team" },
  { value: "firm", label: "Firm" },
  { value: "firm_testimonials", label: "Firm strengths" },
  { value: "lawyer leading_juniors", label: "Leading juniors" },
  { value: "lawyer leading_silks", label: "Leading silks" },
  { value: "lawyer recommended", label: "Lawyer" },
  { value: "lawyer rising_stars", label: "Rising stars" },
  { value: "lawyer_testimonial", label: "Lawyer strengths" },
  { value: "set_testimonial", label: "Set" },
];
